export default __webpack_public_path__ + "static/media/phoneMarket2.5894846b.png";